import { defineComponent as _defineComponent } from 'vue'
import BaseButton from '../BaseButton.vue';
import DatePickerCalendar from './DatePickerCalendar.vue';
import Icon from '../Icon.vue';
import TransitionExpand from '../transitions/TransitionExpand.vue';
import UiButton from '../UiButton.vue';
import { addDays, eachDayOfInterval, isSameDay } from "date-fns/fp";
import { computed, PropType, ref, watch } from 'vue';
import { createDateLookup, DateLookup } from "JS/automotive/auto-service-scheduler/utils/calendar";
import { format } from 'date-fns/fp';
import { v4 as GenUUID } from 'uuid';


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePickerDropdown',
  props: {
	label: String,
	initialDate: Date,
	accessibleCalendarName: {
		type: String,
		required: true,
	},
	accessibleCalendarDescription: {
		type: String,
		required: true,
	},
	availableDates: {
		type: [Number, Object] as PropType<number | DateLookup>,
		required: true,
	},
	size: {
		type: String as PropType<'sm'|'lg'|'responsive'>,
		default: 'responsive',
	},
},
  emits: ["update-date", "toggle"],
  setup(__props, { emit }: { emit: ({
	(event: 'update-date', date: Date): void;
	(event: 'toggle', update: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

//Imports




const showCalendar = ref<boolean>(false);
const selectedDate = ref<Date|null>(props.initialDate);
const dropdownButton = ref<Vue|null>();
const buttonUUID = GenUUID();

const availableCalendarDates = computed(() => {
	return typeof props.availableDates === 'number'
		? createDateLookup(eachDayOfInterval({ start: addDays(1, new Date), end: addDays(props.availableDates, new Date) }))
		: props.availableDates;
});

const displayDate = computed(()=> format('MMMM dd, yyyy', selectedDate.value));

function toggleShowCalendar(shouldOpen: 'open'|'close'|'invert' = 'invert') {
	if (shouldOpen === 'invert') {
		showCalendar.value = !showCalendar.value;
	} else if (shouldOpen === 'open') {
		showCalendar.value = true;
	} else {
		showCalendar.value = false;
	}

	if (!showCalendar.value && !isSameDay(props.initialDate, selectedDate.value)) {
		selectedDate.value = props.initialDate;
	}

	(dropdownButton.value?.$el as HTMLElement)?.focus();
	emit('toggle', showCalendar.value);
}

function handleSelectDate() {
	showCalendar.value = false;
	emit('update-date', selectedDate.value);
}

watch(()=> props.initialDate, (initDate) => {
	toggleShowCalendar('close');
});


return { __sfc: true,props, emit, showCalendar, selectedDate, dropdownButton, buttonUUID, availableCalendarDates, displayDate, toggleShowCalendar, handleSelectDate, BaseButton, DatePickerCalendar, Icon, TransitionExpand, UiButton }
}

})